export default {
  small: '6px',
  base: '9px',
  medium: '13px',
  large: '18px',
  button: '35px',
  round: '50%',
};
